import { Box, Typography } from "@material-ui/core";
import {
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "./epocus-palette";

export const getFirstName = (name: string | undefined): string => {
  if (!name) return "there";
  const parts = name.split(" ");
  if (parts[0]?.toLowerCase().startsWith("dr")) {
    return parts.length > 1 ? `Dr. ${parts[parts.length - 1]}` : parts[0];
  }
  return parts[0] ?? name;
};

export const PerformanceHeader: FC<{
  title: string;
  subtitle: string;
}> = ({ title, subtitle }) => (
  <Box>
    <Typography
      style={{
        fontSize: rem(22),
        fontWeight: 700,
        color: EPOCUS_TEXT_PRIMARY,
        lineHeight: 1.2,
      }}
    >
      {title}
    </Typography>
    <Typography
      style={{ fontSize: rem(13), color: EPOCUS_TEXT_SECONDARY, marginTop: 4 }}
    >
      {subtitle}
    </Typography>
  </Box>
);
